export default "__VITE_ASSET__DffXIOSn__"